import {
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@repo/ui";
import { PATHS } from "routes/paths";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useMemo, useRef } from "react";
import { Upload } from "lucide-react";
import { useGetParentTicketList } from "pages/tickets/utils";
import { StatusContext } from "pages/tickets/constants";
import { useUser } from "hooks/use-user";

export function TicketCreateHeader({
  isDraft = {},
  canCopy = false,
  canUpload = false,
  handleFileChange = () => {},
  onCancel = false,
  onSave = () => {},
  onSaveAsDraft = false,
  onReset = () => {},
  onSubmit = () => {},
}) {
  const user = useUser();
  const isCallCenterAgent = user.Roles.includes("Call Center Agent");
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const fileInputRef = useRef(null);

  const onUpload = () => {
    fileInputRef.current.click();
  };
  const onFileChange = (e) => {
    handleFileChange(e);
    fileInputRef.current.value = "";
  };

  return (
    <>
      <Breadcrumb className="mt-5 text-black">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink>
              <Link
                to={PATHS.allServiceAndNonServiceCalls}
                className="text-black"
              >
                Tickets
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator className="text-black" />

          <BreadcrumbItem>
            <BreadcrumbPage className="text-black">
              Create Ticket
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex flex-row justify-end w-full gap-2 items-center">
        {canUpload && (isCallCenterAgent || isCSMAgent) ? (
          <>
            <Button variant="secondary" onClick={onUpload}>
              <Upload />
            </Button>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={onFileChange}
            />
          </>
        ) : null}

        {isDraft ? (
          <Button variant="secondary" onClick={onSubmit}>
            Submit
          </Button>
        ) : (
          <Button variant="secondary" onClick={onSave}>
            Save
          </Button>
        )}

        <Button variant="secondary" onClick={onSaveAsDraft}>
          Save As Draft
        </Button>
        <Button variant="secondary" onClick={onReset}>
          Reset
        </Button>

        <Link to={PATHS.allServiceAndNonServiceCalls}>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
        </Link>
      </div>
    </>
  );
}
